/* JHERR · Busca por precio (menú del celular): abrir/cerrar y arrastre de la barra.
   - Empieza plegado. Al abrirlo avisa a jherr-price-filter.js ('jh-pf:open') para que cargue relojes.
   - Arrastre propio: funciona igual en iPhone, Android y computadora. Se mueve el extremo más
     cercano al dedo y tocar la barra también lo lleva ahí. El teclado sigue funcionando. */
(function () {
  'use strict';
  if (window.__jhPriceFilterUI) return;
  window.__jhPriceFilterUI = true;

  var THUMB = 28; /* ancho del círculo, igual que en el CSS */

  function setup(root) {
    if (!root || root.__jhUI) return;
    root.__jhUI = true;

    var toggle = root.querySelector('[data-jh-pf-toggle]');
    var body = root.querySelector('[data-jh-pf-body]');
    if (toggle && body) {
      body.inert = true;
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(open));
        root.classList.toggle('is-open', open);
        body.inert = !open;
        if (open) root.dispatchEvent(new CustomEvent('jh-pf:open'));
      });
    }

    var slider = root.querySelector('.jh-pf-slider');
    var minInput = root.querySelector('[data-jh-pf-min]');
    var maxInput = root.querySelector('[data-jh-pf-max]');
    if (!slider || !minInput || !maxInput || !window.PointerEvent) return;
    slider.classList.add('is-custom');

    var dragging = null;
    function rangeMax() { return parseInt(maxInput.max, 10) || 2000; }
    function thumbX(input) {
      var r = input.getBoundingClientRect();
      return r.left + THUMB / 2 + (parseInt(input.value, 10) / rangeMax()) * (r.width - THUMB);
    }
    function valueAt(clientX) {
      var r = maxInput.getBoundingClientRect();
      var ratio = Math.min(1, Math.max(0, (clientX - r.left - THUMB / 2) / (r.width - THUMB)));
      var step = parseInt(maxInput.step, 10) || 10;
      return Math.round(ratio * rangeMax() / step) * step;
    }
    function moveTo(input, clientX) {
      var val = String(valueAt(clientX));
      if (val === input.value) return;
      input.value = val;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    slider.addEventListener('pointerdown', function (e) {
      if (e.button) return;
      var x = e.clientX;
      var dMin = Math.abs(x - thumbX(minInput));
      var dMax = Math.abs(x - thumbX(maxInput));
      dragging = dMin === dMax ? (x < thumbX(maxInput) ? minInput : maxInput) : (dMin < dMax ? minInput : maxInput);
      try { dragging.focus({ preventScroll: true }); } catch (err) {}
      slider.classList.add('is-dragging');
      try { slider.setPointerCapture(e.pointerId); } catch (err) {}
      moveTo(dragging, x);
    });
    slider.addEventListener('pointermove', function (e) { if (dragging) moveTo(dragging, e.clientX); });
    function stop() { dragging = null; slider.classList.remove('is-dragging'); }
    slider.addEventListener('pointerup', stop);
    slider.addEventListener('pointercancel', stop);
    slider.addEventListener('lostpointercapture', stop);
  }

  function boot() { document.querySelectorAll('[data-jh-price-filter]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();